import React from "react";
import DOMPurify from "dompurify";

/**
 * This Element is shared style to display rich message coming in from Notification Message.
 * @param {*} param0
 * @returns
 */
function RichMessage({ children, className, sanitizeConfig = {}, ...props }) {
  // NOTE: We'll want to refine our sanitization strategy to allow for safer render.
  let htmlMessage = DOMPurify.sanitize(children, sanitizeConfig);

  return (
    <div {...props}>
      <span dangerouslySetInnerHTML={{ __html: htmlMessage }} />
    </div>
  );
}

export default RichMessage;
